export { GardenPlanner } from '@modules/garden-planner/views/garden_planner_view';
export { SidebarView } from '@modules/garden-planner/views/sidebar/sidebar_view';
export { GardenView } from '@modules/garden-planner/views/garden_view';
export { GardenGridView } from '@modules/garden-planner/views/garden_grid_view';
export { GardenSummary } from '@modules/garden-planner/views/garden_summary_view';
export { PlantSelectorView } from '@modules/garden-planner/views/plant_selector_view';
export { ShareButtonView } from '@modules/garden-planner/views/sidebar/share_button_view';
export { PlantSelectionToolView } from '@modules/garden-planner/views/sidebar/plant_selection_tool_view';
export { AvailabilityToolView } from '@modules/garden-planner/views/sidebar/availability_tool_view';
export { CellSettingsToolView } from '@modules/garden-planner/views/sidebar/cell_settings_tool_view';
export { ClearPlantsToolView } from '@modules/garden-planner/views/sidebar/clear_plants_tool_view';
export { GridControlsView } from '@modules/garden-planner/views/sidebar/grid_controls_view';
export { AlertMessage } from '@modules/garden-planner/views/alert_message_view';

import type { GardenPlannerViews } from '@modules/garden-planner/garden_planner_views';
import { GardenPlanner } from '@modules/garden-planner/views/garden_planner_view';
import { SidebarView } from '@modules/garden-planner/views/sidebar/sidebar_view';
import { GardenView } from '@modules/garden-planner/views/garden_view';
import { GardenGridView } from '@modules/garden-planner/views/garden_grid_view';
import { GardenSummary } from '@modules/garden-planner/views/garden_summary_view';
import { PlantSelectorView } from '@modules/garden-planner/views/plant_selector_view';
import { ShareButtonView } from '@modules/garden-planner/views/sidebar/share_button_view';
import { PlantSelectionToolView } from '@modules/garden-planner/views/sidebar/plant_selection_tool_view';
import { AvailabilityToolView } from '@modules/garden-planner/views/sidebar/availability_tool_view';
import { CellSettingsToolView } from '@modules/garden-planner/views/sidebar/cell_settings_tool_view';
import { ClearPlantsToolView } from '@modules/garden-planner/views/sidebar/clear_plants_tool_view';
import { GridControlsView } from '@modules/garden-planner/views/sidebar/grid_controls_view';
import { AlertMessage } from '@modules/garden-planner/views/alert_message_view';

export const gardenPlannerWebViews: GardenPlannerViews = {
  GardenPlanner,
  SidebarView,
  GardenView,
  GardenGridView,
  GardenSummary,
  PlantSelectorView,
  ShareButtonView,
  PlantSelectionToolView,
  AvailabilityToolView,
  CellSettingsToolView,
  ClearPlantsToolView,
  GridControlsView,
  AlertMessage,
};
